import gql from "graphql-tag";
import { getAppSyncClient } from "../appsync";

const putTeacher = gql`
  mutation putTeacher(
    $schoolId: String
    $name: String!
    $schoolName: String
    $phone: String
    $email: String
  ) {
    putTeacher(
      input: {
        schoolId: $schoolId
        name: $name
        schoolName: $schoolName
        phone: $phone,
        email: $email
      }
    ) {
      id
      name
      phone
      schoolId
      schoolName
      email
    }
  }
`;

const getTeacher = gql`
  query getTeacher {
    getTeacherDetails {
      id
      schoolId
      schoolName
      name
      subscribed
      appuser_id
      email
    }
  }
`;
const getTeacherSession = gql`
  query getTeacherSessionDashboard(
    $school_id: String!
    $subject: String
    $board: String
    $level: Int
    $section: String
  ) {
    getSessionDashboard(
      school_id: $school_id
      board: $board
      subject: $subject
      level: $level
      section: $section
    )
  }
`;
const getClassLeaderBoard = gql`
  query getClassLeaderBoard(
      $board: String!
      $level: Int!
      $section: String
    ){
    getClassLeaderBoard(
      board: $board
      level: $level
      section: $section
    )
  }
`;

const getClassProgress = gql`
  query getClassProgress(
      $board: String!
      $level: Int!
      $section: String
    ){
      getClassProgress(
      board: $board
      level: $level
      section: $section
    )
  }
`;

const getRecentAssignments = gql`
  query getRecentAssignments(
    $school_id: String!
    $board: String
    $subject: String
    $level: Int
    $section: String
  ) {
    getRecentAssignments(
      school_id: $school_id
      board: $board
      subject: $subject
      level: $level
      section: $section
    )
  }
`;
const getStudentsSession = gql`
  query getRecentSessions($student_id: String!, $session_type: String!) {
    getRecentSessions(student_id: $student_id, session_type: $session_type)
  }
`;
const getStudentChapterProgress = gql`
  query getStudentChapterProgress($student_id: String!) {
    getStudentChapterProgress(student_id: $student_id)
  }
`;
const assignPracticeToClass = gql`
  mutation assignPracticeToClass(
    $school_id: String!
    $board: String!
    $level: Int!
    $section: String
    $subject_id: String!
    $chapter_id: String!
    $teacher_name: String
    $questions: AWSJSON
    $assign_at_iso: String,
    $quiz_duration: Int
  ) {
    assignPracticeToClass(
      school_id: $school_id
      board: $board
      level: $level
      section: $section
      subject_id: $subject_id
      chapter_id: $chapter_id
      teacher_name: $teacher_name
      questions: $questions
      assign_at_iso: $assign_at_iso
      quiz_duration: $quiz_duration
    )
  }
`;
/**
 * bit of confusing names for queries
 * returns class assignment details
 * session_type=classassignment
 */
const getSessionDetails = gql`
  query getSessionDetails($session_id: String!, $session_type: String!) {
    getSessionDetails(session_id: $session_id, session_type: $session_type)
  }
`;

/**
 * this query accepts more params like preselected question , number_of questions and type of question
 * default to h5p, 10 question and no pre selected questions
 */
const getSuggestedChapterQuestion = gql`
  query getChapterQuestions($chapter_id: String!, $subchapter_ids: AWSJSON, $difficulties:[String]) {
    getSuggestedChapterQuestion(
      chapter_id: $chapter_id
      subchapter_ids: $subchapter_ids
      difficulties:$difficulties
    )
  }
`;

const sendInviteMessage = gql`
mutation sendInviteMessage{
  sendInviteMessage
}
`

const addNewQuestion = gql`
  mutation addNewQuestion(
    $chapter_id: String!
    $subchapter_id: String
    $blooms: String
    $difficulty: String
    $content_json: AWSJSON!
    $editor_json: AWSJSON
  ) {
    addNewQuestion(
      chapter_id: $chapter_id
      subchapter_id: $subchapter_id
      blooms: $blooms
      difficulty: $difficulty
      content_json: $content_json
      editor_json: $editor_json
    )
  }
`;

const uploadContentImage = gql`
  mutation uploadContentImage(
    $file: String!
  ) {
    uploadContentImage(file: $file)
  }
`;
export default {
  putTeacher: async (schoolId, name, schoolName, phone, board, grade, email) => {
    const payload = {
      schoolId,
      name,
      schoolName,
      phone,
      board,
      grade,
      email
    };
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const data = await appsyncClient.mutate({
        mutation: putTeacher,
        variables: payload,
      });
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  AssignPracticeToClass: async (
    school_id,
    board,
    level,
    section,
    subject_id,
    chapter_id,
    teacher_name,
    questions = [],
    assign_at_iso = null,
    quiz_duration = null
  ) => {
    const payload = {
      school_id,
      board,
      level,
      section,
      subject_id,
      chapter_id,
      teacher_name,
      questions: JSON.stringify(questions),
      quiz_duration,
      assign_at_iso
    };
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const data = await appsyncClient.mutate({
        mutation: assignPracticeToClass,
        variables: payload,
      });
      const assingedPractice = data.data.assignPracticeToClass;
      return JSON.parse(assingedPractice);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  GetTeacher: async () => {
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const data = await appsyncClient.query({
        query: getTeacher,
        fetchPolicy: "network-only",
      });
      return {
        ...data.data.getTeacherDetails,
        schoolName: data.data.getTeacherDetails.schoolName.split("_")[0],
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  GetTeacherSession: async (
    school_id,
    board,
    level,
    subject = "maths",
    duration = 30,
    section = 'A'
  ) => {
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const variables = { school_id, board, level, subject, duration,section };
      const data = await appsyncClient.query({
        query: getTeacherSession,
        fetchPolicy: "network-only",
        variables,
      });
      const sessions = data.data.getSessionDashboard;
      return JSON.parse(sessions);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  GetClassLeaderBoard: async (  
    board,
    level,
    section = 'A'
  ) => {
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const variables = {board, level, section };
      const data = await appsyncClient.query({
        query: getClassLeaderBoard,
        fetchPolicy: "network-only",
        variables,
      });
      const classLeaderboard = data.data.getClassLeaderBoard;
      return JSON.parse(classLeaderboard);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  GetClassProgress: async (  
    board,
    level,
    section = 'A'
  ) => {
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const variables = {board, level, section };
      const data = await appsyncClient.query({
        query: getClassProgress,
        fetchPolicy: "network-only",
        variables,
      });
      const response = data.data.getClassProgress;
      return JSON.parse(response);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  // getRecentAssignments
  GetRecentAssignment: async (
    school_id,
    board,
    level,
    subject = "maths",
    duration = 30,
    section = 'A'
  ) => {
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const variables = { school_id, board, level, subject, duration, section };
      const data = await appsyncClient.query({
        query: getRecentAssignments,
        fetchPolicy: "network-only",
        variables,
      });
      const recentAssignments = data.data.getRecentAssignments;
      return JSON.parse(recentAssignments);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  GetStudentSessions: async (student_id, session_type = "practice") => {
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const variables = { student_id, session_type };
      const data = await appsyncClient.query({
        query: getStudentsSession,
        fetchPolicy: "network-only",
        variables,
      });
      const sessions = data.data.getRecentSessions;
      return JSON.parse(sessions);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  GetStudentChapterProgress: async (student_id) => {
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const variables = { student_id };
      const data = await appsyncClient.query({
        query: getStudentChapterProgress,
        fetchPolicy: "network-only",
        variables,
      });
      const sessions = data.data.getStudentChapterProgress;
      return JSON.parse(sessions);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  
  GetClassAssignment: async (session_id) => {
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const session_type = "classassignment";
      const variables = { session_id, session_type };

      const data = await appsyncClient.query({
        query: getSessionDetails,
        fetchPolicy: "network-only",
        variables,
      });
      const sessions = data.data.getSessionDetails;
      return JSON.parse(sessions);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  GetSuggestedChapterQuestions: async (chapter_id, subchapter_ids = [], difficulties = []) => {
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const variables = {
        chapter_id,
        subchapter_ids: JSON.stringify(subchapter_ids),
        difficulties
      };
      const data = await appsyncClient.query({
        query: getSuggestedChapterQuestion,
        fetchPolicy: "network-only",
        variables,
      });
      const recentAssignments = data.data.getSuggestedChapterQuestion;
      return JSON.parse(recentAssignments);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  InviteStudent : async()=>{
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const data = await appsyncClient.mutate({
        mutation: sendInviteMessage,
        // variables: payload,
      });
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  AddNewQuestion: async (chapter_id,subchapter_id,blooms,difficulty,content_json,editor_json) => {
    const payload = {
      chapter_id,
      subchapter_id,
      blooms,
      difficulty,  
      content_json: JSON.stringify(content_json),
      editor_json: JSON.stringify(editor_json),
    };
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const data = await appsyncClient.mutate({
        mutation: addNewQuestion,
        variables: payload,
      });
      const addNewQuestionJSON = data.data.addNewQuestion;
      return JSON.parse(addNewQuestionJSON);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  
  UploadContentImage: async (file) => {
    const payload = {
      file
    };
    const appsyncClient = await getAppSyncClient();
    if (!appsyncClient) throw new Error("Quiz app client not initialized");
    try {
      const data = await appsyncClient.mutate({
        mutation: uploadContentImage,
        variables: payload,
      });
      const uploadContentImageResponse = data.data.uploadContentImage;
      return JSON.parse(uploadContentImageResponse);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
};
